// extracted by mini-css-extract-plugin
export default {"gift_card_value":"GiftCards_gift_card_value__IbpUb","gift_card_value_container":"GiftCards_gift_card_value_container__ZUO9q"};